import giftsEn from './gifts/en.json';
import giftsZhHant from './gifts/zh-Hant.json';
import giftsVi from './gifts/vi.json';
import giftsTh from './gifts/th.json';

export default {
  en: giftsEn,
  'zh-Hant': giftsZhHant,
  vi: giftsVi,
  th: giftsTh,
};
